// This file allows routing to access the directory and import all files in the directory.
import app_home from './app_home'
import app_page from './app_page'

export default {
    app_home,
    app_page
}
